import { createFileRoute } from '@tanstack/react-router';
import { SurveysPage } from '@/features/people/pages/surveys-page';

export const Route = createFileRoute('/_app/surveys/')({ component: SurveysPage });
